export class Role {
  private id!: number;
  private name!: string;
  private title!: string;
  private readonly persistence!: boolean;

  public getId(): number {
    return this.id;
  }

  public getName(): string {
    return this.name;
  }

  public getTitle(): string {
    return this.title;
  }

  public get isPersistence(): boolean {
    return this.persistence;
  }

  public get isAdmin(): boolean {
    return this.name === 'admin';
  }

  public get isAccount(): boolean {
    return this.name === 'account';
  }
}
